import { Route, Routes } from 'react-router';

import { AppRoutes } from '@/constants';
import {
  CheckInLogDetailsPage,
  CheckInLogPage,
  FaceIdProfileCreationPage,
  FaceIdProfileDetailsPage,
  FaceIdProfilePage,
  FaceIdProfileUpdatePage,
  IpadConfigurationCreationPage,
  IpadConfigurationDetailsPage,
  IpadConfigurationPage,
  IpadConfigurationUpdatePage,
  LoginPage,
  NoPermission,
  PageNotFound,
  RoleAssignmentCreationPage,
  RoleAssignmentDetailsPage,
  RoleAssignmentPage,
  RoleAssignmentUpdatePage,
  SomethingWentWrong,
} from '@/pages';

import { AuthLayout, ErrorLayout, MainLayout } from '@/components/layouts';

function App() {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path={AppRoutes.HOME} element={<FaceIdProfilePage />} />
        <Route path={AppRoutes.FACE_ID_PROFILES} element={<FaceIdProfilePage />} />
        <Route path={AppRoutes.FACE_ID_PROFILE_CREATION} element={<FaceIdProfileCreationPage />} />
        <Route path={AppRoutes.FACE_ID_PROFILE_UPDATE} element={<FaceIdProfileUpdatePage />} />
        <Route path={AppRoutes.FACE_ID_PROFILE_DETAILS} element={<FaceIdProfileDetailsPage />} />
        <Route path={AppRoutes.IPAD_CONFIGURATIONS} element={<IpadConfigurationPage />} />
        <Route
          path={AppRoutes.IPAD_CONFIGURATION_CREATION}
          element={<IpadConfigurationCreationPage />}
        />
        <Route
          path={AppRoutes.IPAD_CONFIGURATION_UPDATE}
          element={<IpadConfigurationUpdatePage />}
        />
        <Route
          path={AppRoutes.IPAD_CONFIGURATION_DETAILS}
          element={<IpadConfigurationDetailsPage />}
        />
        <Route path={AppRoutes.CHECK_IN_LOGS} element={<CheckInLogPage />} />
        <Route path={AppRoutes.CHECK_IN_LOG_DETAILS} element={<CheckInLogDetailsPage />} />
        <Route path={AppRoutes.ROLE_ASSIGNMENTS} element={<RoleAssignmentPage />} />
        <Route path={AppRoutes.ROLE_ASSIGNMENT_CREATION} element={<RoleAssignmentCreationPage />} />
        <Route path={AppRoutes.ROLE_ASSIGNMENT_UPDATE} element={<RoleAssignmentUpdatePage />} />
        <Route path={AppRoutes.ROLE_ASSIGNMENT_DETAILS} element={<RoleAssignmentDetailsPage />} />
      </Route>
      <Route element={<ErrorLayout />}>
        <Route path={AppRoutes.FORBIDDEN} element={<NoPermission />} />
        <Route path={AppRoutes.INTERNAL_SERVER_ERROR} element={<SomethingWentWrong />} />

        {/* 404 - Wildcard route to catch all unmatched routes */}
        <Route path="*" element={<PageNotFound />} />
      </Route>
      <Route element={<AuthLayout />}>
        <Route path={AppRoutes.LOGIN_PAGE} element={<LoginPage />} />
      </Route>
    </Routes>
  );
}

export default App;
